const TAB_KEY = 'contactInfo'
export default {
  name: 'contactInfo',

  computed: {
    contactInfoCreateConfig () {
      return {
        title: this.$t('administration/partner.contact_data'),
        key: TAB_KEY,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            component: this.columnsContentComponent,
            title: this.$t('administration/partner.contact_data'),
            showButtons: false,
            mainDivStyle: {
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1
            },
            cardStyle: {
              flexGrow: 1
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'phone_number_1',
                    label: this.$t('people/person.phone_number'),
                    placeholder: this.$t('people/person.enter_phone_number'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'phone_number_2',
                    label: this.$t('people/person.phone_number_2'),
                    placeholder: this.$t('people/person.enter_phone_number_2'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'fax',
                    label: this.$t('administration/partner.fax'),
                    placeholder: this.$t('administration/partner.enter_fax'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'email',
                    label: this.$t('administration/partner.email'),
                    placeholder: this.$t('administration/partner.enter_email'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'contact_person',
                    label: this.$t('administration/partner.contact_person'),
                    placeholder: this.$t('administration/partner.enter_contact_person'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
